import { useId, useState, type FormEvent } from 'react';
import { useLocale } from '../i18n/locale';
import { CONTACT_EMAIL, sectionId } from '../content/site';
import { START, START_IDS, startIntake, type StartId } from '../content/start';
import { HOME } from './content';
import { Lines } from './Lines';

/**
 * The project brief — the commercial close. The buyer says where the purchase is today (a need, a
 * specification, or a supplier/quotation) and writes the requirement; both travel to the intake.
 * One flow, one form; the composer's hint adapts to the chosen starting point.
 */
export function Close() {
  const { locale } = useLocale(); const copy = HOME[locale].close; const start = START[locale];
  const [state, setState] = useState<StartId | ''>('');
  const [text, setText] = useState('');
  const field = useId(); const hint = useId();
  const submit = (event: FormEvent) => { event.preventDefault(); startIntake(locale, { need: text, start: state }); };
  return (
    <section id={sectionId('start', locale)} className="close" data-tone="light" aria-labelledby="close-title">
      <form className="close__inner wrap" onSubmit={submit}>
        <div className="brief__lead">
          <h2 id="close-title" className="close__title">{copy.title}</h2>
          <p className="brief__body"><Lines lines={copy.body} /></p>
          <fieldset className="brief__states">
            <legend className="brief__legend">{start.label}</legend>
            {START_IDS.map(id => (
              <label key={id} className="brief__state" data-selected={state === id}>
                <input type="radio" name="start" value={id} checked={state === id} onChange={() => setState(id)} />
                <span className="brief__state-mark" aria-hidden="true" />
                <span className="brief__state-title">{start.options[id].title}</span>
                <span className="brief__state-body">{start.options[id].body}</span>
              </label>
            ))}
          </fieldset>
        </div>
        <div className="brief__composer">
          <label className="brief__label" htmlFor={field}>{copy.composer}</label>
          <p id={hint} className="brief__hint" aria-live="polite">{state ? start.options[state].hint : ' '}</p>
          <textarea id={field} className="brief__field" rows={4} maxLength={2000} value={text} aria-describedby={hint}
            placeholder={copy.placeholder.join('\n')} onChange={event => setText(event.target.value)} />
          <div className="brief__actions">
            <button type="submit" className="cta cta--primary">{copy.action}</button>
            {CONTACT_EMAIL && <a className="close__secondary" href={`mailto:${CONTACT_EMAIL}`}>{copy.secondary}</a>}
          </div>
        </div>
        <div className="brief__next">
          <p className="brief__next-label">{copy.nextLabel}</p>
          <ol>{copy.next.map((step, index) => <li key={step}><span className="brief__next-num">{String(index + 1).padStart(2, '0')}</span>{step}</li>)}</ol>
        </div>
      </form>
    </section>
  );
}
